"use strict";

var _interopRequireDefault = require("/build-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es6.reflect.construct");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));
var _getPrototypeOf2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));
var _inherits2 = _interopRequireDefault(require("/build-app/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));
var _serviceBase = _interopRequireDefault(require("@/services/service-base"));
var _qs = _interopRequireDefault(require("qs"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var domain = process.env.VUE_APP_BASE_API_LOGIN;
// 权限设置
var SiteAdminService = /*#__PURE__*/function (_Service) {
  function SiteAdminService() {
    (0, _classCallCheck2.default)(this, SiteAdminService);
    return _callSuper(this, SiteAdminService, arguments);
  }
  (0, _inherits2.default)(SiteAdminService, _Service);
  return (0, _createClass2.default)(SiteAdminService, [{
    key: "getList",
    value:
    // 站点地址_列表
    function getList(param) {
      return this.http.get("/api/v4/site/list?".concat(_qs.default.stringify(param)));
    }
    // 查询那些用户绑定过站点
  }, {
    key: "inquire",
    value: function inquire(param) {
      return this.http.get("/api/v4/get/siteuser?".concat(_qs.default.stringify(param)));
    }
    // 返回不存在的站点的用户列表(通用后台)
  }, {
    key: "backData",
    value: function backData(data) {
      data.pid = process.env.VUE_APP_PID;
      return this.http.post(domain + '/vwk/user/notSiteUser', data);
    }
    // 站点地址 - 编辑
  }, {
    key: "editData",
    value: function editData(id, data) {
      return this.http.post('/api/v4/site/userSiteEdit/' + id, data);
    }
    // 返回全部绑定站点数据
  }, {
    key: "binding",
    value: function binding(param) {
      return this.http.get('/api/v4/siteuser/list', {
        params: param
      });
    }
    // 区分请求站点
  }, {
    key: "different",
    value: function different(data) {
      return this.http.post('/api/v4/site', data, {
        // return this.http.get(`/api/v4/site?${qs.stringify(data)}`,{
        headers: {
          // user: localStorage.getItem('name'),
          // username: localStorage.getItem('userNickname')
          // 需要解码========
          user: encodeURIComponent(localStorage.getItem('name')),
          username: encodeURIComponent(localStorage.getItem('userNickname'))
        }
      });
    }
  }]);
}(_serviceBase.default);
var _default = exports.default = new SiteAdminService();